<template>
  <fragment>
    <page-head small :title="requestType.title" back-route-path="/cases/case-related-request"> </page-head>
    <page-content small>
      <div>
        <!-- <naj-alert v-if="isNajizCitizen" type="information">
          <template slot="content">
            {{ local.caseRelatedRequest.reconsiderationFromNonCaseParty.lawyerNotificationMessage }}
          </template>
        </naj-alert> -->
        <v-form v-if="requireSearch" ref="searchFormRef" @submit.prevent="onSearch">
          <naj-box title="تفاصيل القضية" has-footer>
            <v-row>
              <v-col cols="3">
                <naj-input
                  :type-id="formFieldType.number"
                  :label="local.caseRelatedRequest.filters.caseCode"
                  :value.sync="searchQuery.caseCode"
                  validates="required|long|max:10"
                  @input="filterChanged"
                ></naj-input>
              </v-col>
              <v-col cols="3">
                <naj-input
                  :type-id="formFieldType.number"
                  :label="local.caseRelatedRequest.filters.year"
                  :value.sync="searchQuery.caseYear"
                  validates="required"
                  @input="filterChanged"
                ></naj-input>
              </v-col>
              <v-col cols="3">
                <naj-input
                  :type-id="formFieldType.number"
                  :label="local.caseRelatedRequest.filters.judgementCode"
                  :value.sync="searchQuery.judgmentCode"
                  validates="required|long"
                  @input="filterChanged"
                ></naj-input>
              </v-col>
              <v-col cols="3">
                <naj-input
                  :type-id="formFieldType.text"
                  :label="local.caseRelatedRequest.filters.identityNumber"
                  :value.sync="searchQuery.identityNumber"
                  validates="required"
                  @input="filterChanged"
                ></naj-input>
              </v-col>
            </v-row>
            <template v-slot:footer>
              <span />
              <naj-button outlined type="button" color="primary" icon="mdi-magnify" :loading="loading" @click="onSearch">
                {{ local.common.search }}
              </naj-button>
            </template>

            <naj-data-table
              v-if="!!formModel.case"
              no-header
              disable-items-per-page
              :headers="tableHeader"
              :loading="loading"
              :items="formModel.case ? [formModel.case] : []"
              :no-margin-bottom="false"
            ></naj-data-table>
            <v-row>
              <v-col cols="1" class="judgement-deed">
                <naj-button v-if="!!formModel.case" @click="handleViewAttachment(formModel.case)">
                  {{ local.caseRelatedRequest.reconsiderationFromNonCaseParty.displayJudgement }}
                </naj-button>
              </v-col>
            </v-row>
          </naj-box>
        </v-form>
      </div>
      <div>
        <v-form v-if="formModel.case" ref="requestFormRef">
          <request-applicant-details :view-mode="false" :form-model.sync="formModel"></request-applicant-details>

          <naj-box v-if="requestType.showRequestReasonSection" :title="local.caseRelatedRequest.requestReasons">
            <span class="request-reasons-warning">
              <v-icon color="#FAAD14">
                mdi-alert
              </v-icon>
              {{ local.caseRelatedRequest.requestReasonsWarning }}
            </span>
            <br />
            <br />

            <template v-if="formModel.requestReasons.length > 0">
              <naj-box
                v-for="(requestReason, index) in formModel.requestReasons"
                :key="index"
                :title="getMappedIndexReasonText(index)"
              >
                <v-row>
                  <v-col cols="6">
                    <template v-if="requestReason.isDraft">
                      <naj-input
                        v-if="isRequestReasonTypeSelectbox"
                        :type-id="formFieldType.selectbox"
                        label="السبب"
                        :value.sync="reasonId"
                        :items="requestTypeRequestReasons"
                        item-text="description"
                        item-value="id"
                        :clearable="false"
                        @change="setSelectedRequestReason"
                      ></naj-input>

                      <naj-input
                        v-if="isRequestReasonTypeTextarea"
                        :type-id="formFieldType.textarea"
                        label="السبب"
                        :value.sync="requestReasonInput"
                        :counter="requestType.id == 70 ? 2000 : 256"
                        validates="allowed_special_character"
                      ></naj-input>
                    </template>

                    <span v-else>
                      <label class="request-reason-label"> السبب</label>
                      <div>
                        <span class="request-reason-text">
                          {{ requestReason.reasonText }}
                        </span>
                      </div>
                    </span>
                  </v-col>

                  <v-col class="text-center" cols="4">
                    <template v-if="requestType.requestReasonTypeConfig.showRequestReasonAttachment">
                      <label class="request-reason-label"> {{ local.attachments.attachment }}</label>
                      <div
                        v-if="requestReason.sharePointId && requestReason.sharePointFileName"
                        class="d-flex justify-content-center align-items-center file-name h-75"
                      >
                        {{ requestReason.sharePointFileName }}
                      </div>
                      <div
                        v-if="(!requestReason.sharePointId || !requestReason.sharePointFileName)"
                        class="d-flex justify-content-center h-75 file-upload-icon"
                        @click="openRequestReasonAttachmentModal(index)"
                      >
                        <v-icon>
                          mdi-cloud-upload
                        </v-icon>
                      </div>
                    </template>
                  </v-col>

                  <v-col class="d-flex justify-content-end align-items-center" cols="2">
                    <template v-if="requestReason.isDraft">
                      <naj-button :disabled="isAllowToSaveReason" @click="appendRequestReason(index)">
                        {{ local.common.save }}
                      </naj-button>
                      <naj-button outlined @click="discardRequestReason(index)">
                        {{ local.common.cancel }}
                      </naj-button>
                    </template>
                    <template v-else>
                      <v-btn
                        v-if="requestReason.sharePointId && requestReason.sharePointFileName"
                        icon
                        @click="handleViewAttachment(requestReason)"
                      >
                        <v-icon>
                          mdi-eye
                        </v-icon>
                      </v-btn>

                      <v-btn
                        v-if="!requestReason.isDraft"
                        icon
                        @click="
                          activeReason = index;
                          showDeleteReasonConfirmationModal = true;
                        "
                      >
                        <v-icon color="red">
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-col>
                </v-row>
              </naj-box>
            </template>
            <v-row>
              <v-col v-if="formModel.requestReasons.length < 5" cols="1" class="mb-6">
                <naj-button :disabled="isDraftExist" icon="mdi-plus" @click="handleAddReason"> </naj-button>
              </v-col>
            </v-row>
          </naj-box>

          <naj-confirmation
            :show-modal="showDeleteReasonConfirmationModal"
            title="تأكيد"
            message="هل أنت متأكد من حذف السبب؟"
            ok-btn-label="نعم"
            close-btn-label="لا"
            @ok="
              () => {
                showDeleteReasonConfirmationModal = false;
                handleRemoveReason();
              }
            "
            @cancel="showDeleteReasonConfirmationModal = false"
          ></naj-confirmation>

          <div v-if="requestType.customComponentName">
            <naj-dynamic-form
              :custom-component-name="requestType.customComponentName"
              :required-data="requestCustomData"
              :form-model="formModel"
              :view-mode="false"
            ></naj-dynamic-form>
          </div>

          <naj-box :title="local.caseFile.tabHeaders.fees">
            <v-row>
              <v-col cols="12">
                <span class="request-reasons-warning">
                  <v-icon color="#FAAD14">
                    mdi-alert
                  </v-icon>
                  {{ local.caseFile.fees.title }}
                </span>
                <div>
                  <span v-if="requestTypeFeesDescription" class="request-reason-text">
                    {{ requestTypeFeesDescription }}
                  </span>
                  <span v-else class="request-reason-text">
                    {{ local.caseFile.fees.noFees }}
                  </span>
                </div>
              </v-col>
            </v-row>
          </naj-box>

          <v-row>
            <v-col cols="12" class="text-left">
              <naj-button @click="validateCaseRelatedRequestThenSubmit">
                {{ local.common.saveAndSend }}
              </naj-button>
              <naj-confirmation
                :show-modal="showSendRequestConfirmationModal"
                :title="local.common.confirmationSendRequest"
                :message="local.caseRelatedRequest.sendRequestConfirmationMessage"
                :ok-btn-label="local.common.yes"
                :close-btn-label="local.common.no"
                @ok="onSubmit"
                @cancel="showSendRequestConfirmationModal = false"
              ></naj-confirmation>
            </v-col>
          </v-row>

          <attachment-modal
            ref="attachmentModalComponent"
            :attachment="selectedAttachment"
            :attachment-categories="attachmentCategories"
            :attachments-data="attachmentsDataArray"
            modal-button-text=""
            :action-text="local.attachments.addToRequest"
            :view-mode="false"
            accept="image/*,application/pdf"
            :max-file-size="5"
            @onClose="attachmentModalClosed"
            @onSubmit="submitUploadAttachment"
          ></attachment-modal>

          <naj-confirmation
            :show-modal="deleteModalVisibility"
            color="error"
            :title="local.common.removeConfirmation"
            :message="local.common.removeConfirmationMessage"
            :ok-btn-label="local.common.remove"
            @ok="
              () => {
                deleteModalVisibility = false;
                handleDeleteAttachment();
              }
            "
            @cancel="deleteModalVisibility = false"
          ></naj-confirmation>
        </v-form>
      </div>

      <request-reason-modal
        :modal-visibility="showRequestReasonAttachmentModal"
        @addRequestReasonAttachment="addRequestReasonAttachment"
        @onClose="hideRequestReasonAttachmentModal"
      >
      </request-reason-modal>

      <render-attachment-modal
        :attachment-file="selectedFile"
        :modal-visibility="showViewAttachmentModal"
        @modalClose="hideViewAttachmentModal"
      >
      </render-attachment-modal>

      <naj-confirmation
        :show-modal="showInformationModal"
        :max-width="750"
        :is-persistent="true"
        :title="local.caseRelatedRequest.successAlertMessage"
        :close-btn-label="local.common.close"
        @cancel="closeInformationModal"
      >
        <template slot="message-content">
          <v-row>
            <v-col>
              <naj-alert type="success">
                <template slot="content">
                  {{ local.caseRelatedRequest.requestSendSuccessfully }}، {{ local.caseRelatedRequest.requestCode }}
                  {{ requestCodeResult }}
                </template>
              </naj-alert>
            </v-col>
          </v-row>
        </template>
      </naj-confirmation>

      <naj-confirmation
        :show-modal="showValidationSummaryModal"
        :max-width="1000"
        :is-persistent="true"
        :title="`${local.caseRelatedRequest.validationSummaryTitle}`"
        :close-btn-label="local.common.close"
        @cancel="
          () => {
            showValidationSummaryModal = false;
            validationSummaryText = '';
          }
        "
      >
        <template slot="message-content">
          <v-row>
            <v-col>
              <naj-alert type="error">
                <template slot="content">
                  <div v-html="validationSummaryText" />
                </template>
              </naj-alert>
            </v-col>
          </v-row>
        </template>
      </naj-confirmation>
    </page-content>
  </fragment>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { RequestTypes, RequestTypesNames, mode, userType, applicantRole, partyTypeEnum } from '@/helpers/enum';
import { resetScroll, uuidGenerator } from '@/helpers/utils';
import AttachmentModal from '@/components/shared/attachment-modal/index';
import RequestReasonModal from '@/components/shared/request-reason-modal/index';
import RenderAttachmentModal from '@/components/shared/attachment-modal/render-attachment-modal';
import RequestApplicantDetails from './request-applicant-details';

const { mapActions } = createNamespacedHelpers('CasesModule');
const { mapState: mapLawsuitState } = createNamespacedHelpers('LawsuitModule');
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers('LookupsModule');
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapActions: mapSysActions } = createNamespacedHelpers('SystemModule');

export default {
  components: {
    AttachmentModal,
    RequestReasonModal,
    RenderAttachmentModal,
    RequestApplicantDetails,
  },
  data() {
    return {
      mode,
      request: {},
      showSendRequestConfirmationModal: false,
      loading: false,
      RequestTypes,
      RequestTypesNames,
      searchQuery: {
        objectKey: null,
        caseCode: null,
        caseYear: null,
        courtId: null,
        isPega: false,
        casePartyType: null,
        socialTypeId: null,
        socialId: null,
        commercialRegistrationNumber: null,
        organizationId: null,
        name: null,
        judgmentCode: null,
        identityNumber: null,
      },
      requestCustomData: null,
      caseParties: [],
      userCasePartyRoleInCase: {},
      isLoggedInUserExistsAsCaseParty: false,
      requestTypeFeesDescription: null,
      requestTypeRequestReasons: [],
      selectedRequestReason: {},
      tableHeader: [
        {
          value: 'caseCode',
          text: this.local.caseReply.tableHeader.caseCode,
        },
        {
          value: 'caseDate',
          text: this.local.caseReply.tableHeader.caseDate,
        },
        {
          value: 'courtName',
          text: this.local.caseReply.tableHeader.court,
        },
        {
          value: 'subCircleName',
          text: this.local.caseReply.tableHeader.circle,
        },
        {
          value: 'caseStatusName',
          text: this.local.caseReply.tableHeader.caseStatusName,
        },
        {
          value: 'caseCategoryName',
          text: this.local.caseReply.tableHeader.caseCategoryName,
        },
        {
          value: 'caseTypeName',
          text: this.local.caseReply.tableHeader.caseType,
        },
      ],
      formModel: {
        requestType: 50,
        applicantRoleId: null,
        requestReasons: [],
        attachments: [],
        applicantInfo: {},
        representationInfoDetails: null,
        judgementCode: null,
        argument: null,
        stopExecution: null,
        stopExecutionNotes: null,
        originalPersonParty: null,
        representative: null,
      },

      // reasons
      showDeleteReasonConfirmationModal: false,
      activeReason: null,
      reasonId: null,
      requestReasonInput: '',

      // attachments
      selectedAttachment: null,
      deleteModalVisibility: false,
      activeAttachment: null,
      showRequestReasonAttachmentModal: false,
      showInformationModal: false,
      requestCodeResult: '',
      showValidationSummaryModal: false,
      validationSummaryText: '',
      showViewAttachmentModal: false,
      selectedFile: {},
      applicantRole,
    };
  },
  computed: {
    ...mapLawsuitState({ attachmentsData: (state) => state.attachments.data }),
    ...mapLUTState(['attachmentCategories']),
    ...mapGlobalState(['userInfo', 'qaimConfig']),
    isGovernmentalUser() {
      return this.userInfo.loginType == 'governmental';
    },
    isNajizCitizen() {
      return this.userInfo && this.userInfo.userType === userType.najizCitizen;
    },
    attachmentsDataArray() {
      return Object.values(this.attachmentsData);
    },
    requestType() {
      return this.RequestTypes[this.$route.params.requestType] || {};
    },

    requireSearch() {
      return !this.$route.params.caseObjectKey;
    },
    isDraftExist() {
      return (this.formModel.requestReasons || []).some((a) => a.isDraft);
    },
    formModelCaseObjectKey() {
      return (this.formModel.case || {}).objectKey;
    },
    formModelRequestObjectKey() {
      return (this.formModel || {}).objectKey;
    },
    isRequestReasonTypeTextarea() {
      return (
        this.requestType.requestReasonTypeConfig.fieldType == this.formFieldType.textarea ||
        this.selectedRequestReason.isOtherReason
      );
    },
    isRequestReasonTypeSelectbox() {
      return this.requestType.requestReasonTypeConfig.fieldType == this.formFieldType.selectbox;
    },
    isAllowToSaveReason() {
      const isSpecialCharacterErrorExist = this.errors.items.some((r) => r.rule === 'allowed_special_character');
      if (this.requestType.id === RequestTypesNames.verdictObjection.id)
        return (
          this.requestReasonInput.trim().length > 2000 ||
          this.requestReasonInput.trim().length < 1 ||
          isSpecialCharacterErrorExist
        );
      else
        return (
          this.requestReasonInput.trim().length > 256 || this.requestReasonInput.trim().length < 1 || isSpecialCharacterErrorExist
        );
    },
    applicantDetails() {
      return (
        this.formModel.applicantRoleId +
        '_' +
        (this.formModel.applicantInfo || {}).socialId +
        '_' +
        (this.formModel.originalPersonParty || {}).socialId
      );
    },
    isLawyer() {
      return this.userInfo.userType === userType.najizLawyer;
    },
    isOrganizationUser() {
      return this.userInfo.isOrganizationUser;
    },
  },
  watch: {
    formModelCaseObjectKey(value) {
      if (this.isRequestReasonTypeSelectbox && value) {
        this.loadRequestTypeRequestReasons();
      }
    },
    applicantDetails(value) {
      if (value) {
        this.loadRequestTypeFeesDescription();
      }
    },
  },
  async created() {
    if (this.$route.params.caseObjectKey) {
      await this.userHasPermissionCaseRelatedRequest(this.$route.params.caseObjectKey).catch((error) => this.$router.push('/'));
    }
  },
  mounted() {
    this.getAttachmentCategories();
    this.$set(this.formModel, 'requestType', this.requestType.id);
    if (this.$route.params.caseObjectKey) {
      this.searchOnBehalfUser();
    }
  },
  methods: {
    ...mapLUTActions(['getAttachmentCategories']),
    ...mapActions([
      'inquiryCase',
      'validateCaseRelatedRequest',
      'saveCaseRelatedRequest',
      'uploadAttachment',
      'getRequestTypeRequestReasons',
      'userHasPermissionCaseRelatedRequest',
      'getRequestFeesInfo',
    ]),
    ...mapSysActions(['validateLawyer']),
    filterChanged() {
      this.$set(this, 'formModel', {
        requestType: 50,
        applicantRoleId: null,
        requestReasons: [],
        attachments: [],
        applicantInfo: {},
        representationInfoDetails: this.isLawyer ? { casePartyRole: 5 } : (this.isOrganizationUser ? { casePartyRole: 10 } : null),
        judgementCode: null,
        argument: null,
        stopExecution: null,
        stopExecutionNotes: null,
        originalPersonParty: this.isLawyer || this.isOrganizationUser ? { casePartyRole: 10009 } : null,
        representative: null,
      });
    },
    searchOnBehalfUser() {
      this.searchQuery.objectKey = this.$route.params.caseObjectKey;
      this.searchQuery.isPega = true;
      this.onSearch();
    },
    onSearch() {
      Promise.all([
        this.requireSearch ? this.$refs.searchFormRef.$validator.validateAll() : Promise.resolve(true),
        this.$refs.searchInfo ? this.$refs.searchInfo.$validator.validateAll() : Promise.resolve(true),
      ]).then((results) => {
        if (results.every((i) => i)) {
          this.loading = true;
          this.inquiryCase(this.searchQuery)
            .then(({ data }) => {
              if (data.caseCode) {
                this.$set(this.formModel, 'case', {
                  ...this.searchQuery,
                  ...data,
                });
                this.requestCustomData = {
                  ...data,
                  partyType: this.searchQuery.partyType,
                };
              } else {
                this.toaster.error(this.local.caseRelatedRequest.notFound);
              }
            })
            .catch((err) => !err.handled && this.toaster.error(err.message))
            .finally(() => (this.loading = false));
        }
      });
    },
    validateCaseRelatedRequestThenSubmit() {
      this.$refs.requestFormRef.$validator.validateAll().then((valid) => {
        if (valid) {
          this.formModel.judgementCode = this.searchQuery.judgmentCode;
          this.loading = true;
          const payload = {
            objectKey: this.formModel.objectKey || uuidGenerator(),
            data: {
              ...this.formModel,
              isPega: true,
              requestType: this.requestType,
            },
          };
          this.validateCaseRelatedRequest(payload)
            .then(() => {
              this.showSendRequestConfirmationModal = true;
            })
            .catch((err) => this.toaster.error(err))
            .finally(() => (this.loading = false));
        } else {
          resetScroll();
        }
      });
    },
    onSubmit() {
      if (this.isLawyer) {
        this.validateLawyer({
          socialId: this.formModel.applicantInfo.socialId,
          isTraineeLawyer: false,
        }).then(() => this.save());
      } else {
        this.save();
      }
    },
    save() {
      const payload = {
        isPega: true,
        objectKey: this.formModel.objectKey || uuidGenerator(),
        data: {
          ...this.formModel,
          isPega: true,
          case: {
            ...this.formModel.case,
            id: this.formModel.case.caseId || this.formModel.case.id,
          },
          applicantPartyType: this.isOrganizationUser ? (this.isGovernmentalUser ? 4 : 2) : 1,
        },
      };
      this.saveCaseRelatedRequest(payload)
        .then((result) => {
          this.showSendRequestConfirmationModal = false;
          this.requestCodeResult = result.data.requestCode;
          this.showInformationModal = true;
        })
        .catch((err) => {
          if (err.handled) {
            this.showSendRequestConfirmationModal = false;
            this.showValidationSummaryModal = true;
            this.validationSummaryText = err.message;
          } else {
            this.toaster.error(err.message);
          }
        })
        .finally(() => (this.loading = false));
    },
    // reasons
    handleAddReason() {
      this.formModel.requestReasons.push({
        reasonId: this.reasonId,
        reasonText: this.requestReasonInput,
        isDraft: true,
      });
    },
    appendRequestReason(index) {
      const duplicateReasonExists = this.formModel.requestReasons.some(
        (r) => r.reasonText == this.requestReasonInput && r.reasonId == this.reasonId,
      );
      if (duplicateReasonExists) {
        this.toaster.error(this.local.caseRelatedRequest.canNotAddDuplicateReason);
        return;
      }
      this.formModel.requestReasons[index].reasonText = this.requestReasonInput;
      this.formModel.requestReasons[index].reasonId = this.reasonId || 1;
      this.formModel.requestReasons[index].isDraft = false;
      this.resetRequestReasonFields();
    },
    discardRequestReason(index) {
      this.formModel.requestReasons.splice(index, 1);
      this.resetRequestReasonFields();
    },
    handleRemoveReason(index = this.activeReason) {
      this.formModel.requestReasons.splice(index, 1);
    },
    //fees
    loadRequestTypeFeesDescription() {
      if (this.formModel && this.formModel.applicantInfo && this.formModel.applicantInfo.socialId) {
        this.loading = true;
        let applicant = this.formModel?.originalPersonParty?.socialId
          ? this.formModel.originalPersonParty
          : this.formModel.applicantInfo;

        if (this.formModel.applicantRoleId === this.applicantRole.organizationRepresentative) {
          applicant = this.formModel.originalPersonParty;
        }

        const identityNumber = this.formModel.applicantRoleId !== this.applicantRole.organizationRepresentative
          ? applicant.socialId
          : (this.formModel.originalPersonParty.unifiedNumber ?? this.formModel.originalPersonParty.commercialRegistrationNumber);

        const partyTypeId = this.formModel.applicantRoleId !== this.applicantRole.organizationRepresentative
          ? partyTypeEnum.person
          : (this.isGovernmentalUser ? partyTypeEnum.government : partyTypeEnum.firm);

        const params = {
          requestTypeId: 50,
          caseObjectKey: this.formModelCaseObjectKey,
          applicantCasePartyId: 0,
          applicantInfo: {
            identityNumber: identityNumber,
            identityTypeId: applicant.socialIdType,
            partyTypeID: partyTypeId,
          },
        };
        this.getRequestFeesInfo(params)
          .then(({ data }) => {
            this.requestTypeFeesDescription = data.description;
          })
          .catch(() => {})
          .finally(() => {
            this.loading = false;
          });
      }
    },
    // attachments
    showModal(id) {
      this.$refs.attachmentModalComponent.showModal(id);
    },
    handleViewAttachment(file) {
      this.$set(this, 'selectedFile', {
        name: file.fileName || file.sharePointFileName,
        isImage: !file.extension ? null : file.extension.startsWith('image'),
        sharePointId: file.sharePointId ?? file.sharepointId,
      });
      this.showViewAttachmentModal = true;
    },
    handleDeleteAttachment(index = this.activeAttachment) {
      this.formModel.attachments.splice(index, 1);
    },
    attachmentSelected(attachment) {
      this.selectedAttachment = attachment;

      if (attachment && this.$refs.attachmentModalComponent) {
        this.$refs.attachmentModalComponent.showModal();
      }
    },
    attachmentModalClosed() {},
    submitUploadAttachment({ attachment }) {
      this.loading = true;
      const reader = new FileReader();
      const self = this;

      reader.onloadend = () => {
        var b64 = reader.result.replace(/^data:.+;base64,/, '');

        self
          .uploadAttachment({
            classification: 0,
            documentMetadata: {
              caseId: 0,
              caseCode: 0,
              requestId: 0,
              category: attachment.category,
              fileCategory: attachment.category,
            },
            fileCategory: attachment.category,
            extension: attachment.extension,
            base64FileContent: b64,
          })
          .then(({ data }) => {
            self.formModel.attachments.push({
              fileName: attachment.name,
              extension: attachment.extension,
              sharePointId: data,
              fileCategory: attachment.category,
            });

            this.$refs.attachmentModalComponent.closeModal();
          })
          .catch((err) => this.toaster.error(err.message))
          .finally(() => (this.loading = false));
      };

      reader.readAsDataURL(attachment.fileObject);
    },
    getMappedIndexReasonText(index) {
      switch (index) {
        case 0:
          return 'السبب الأول';
        case 1:
          return 'السبب الثاني';
        case 2:
          return 'السبب الثالث';
        case 3:
          return 'السبب الرابع';
        case 4:
          return 'السبب الخامس';
        default:
          return '';
      }
    },
    addRequestReasonAttachment(file) {
      this.formModel.requestReasons[this.activeReason].sharePointId = file.sharePointId;
      this.formModel.requestReasons[this.activeReason].sharePointFileName = file.sharePointFileName;
      this.formModel.requestReasons[this.activeReason].extension = file.extension;
    },
    openRequestReasonAttachmentModal(index) {
      this.activeReason = index;
      this.showRequestReasonAttachmentModal = true;
    },
    hideRequestReasonAttachmentModal() {
      this.activeReason = null;
      this.showRequestReasonAttachmentModal = false;
    },
    closeInformationModal() {
      this.$router.push({ path: '/' });
      this.showInformationModal = false;
    },
    loadRequestTypeRequestReasons() {
      this.loading = true;
      this.getRequestTypeRequestReasons(this.requestType.id)
        .then(({ data }) => {
          this.requestTypeRequestReasons = data;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    setSelectedRequestReason() {
      this.selectedRequestReason = this.requestTypeRequestReasons.find((r) => r.id == this.reasonId) || {};
      if (!this.selectedRequestReason.isOtherReason) {
        this.requestReasonInput = this.selectedRequestReason.description;
      } else {
        this.requestReasonInput = '';
      }
    },
    resetRequestReasonFields() {
      this.requestReasonInput = '';
      this.reasonId = null;
      this.selectedRequestReason = {};
    },
    hideViewAttachmentModal() {
      this.showViewAttachmentModal = false;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .request-info-root {
    background-color: var(--app-light-secondary-color);
    padding: 10px 20px;
    border-radius: 5px;
    border: 1px solid var(--app-primary-color);
    margin-bottom: 20px;

    > div {
      min-width: 170px;

      > b {
        display: flex;
        width: 100%;
        justify-content: space-between;
        font-weight: 700;
        margin-bottom: 5px;

        > span {
          margin-right: 0;
          margin-left: 5px;
        }
      }
    }
  }
}

.request-reasons-warning {
  font-size: 16px;
  color: #faad14;
}

.request-reason-label {
  font-size: 20px;
}

.request-reason-text {
  font-size: 15px;
  color: #484952a0;
}

.content-wrapper {
  border: 1px solid #e4e5e6 !important;
  margin-bottom: 25px;
}

.file-name {
  font-size: 18px;
}

.file-upload-icon {
  cursor: pointer;
}
</style>
